import { CdkDialogContainer } from '@angular/cdk/dialog';
import { CdkPortalOutlet } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-pop-in',
    templateUrl: './pop-in.html',
    styleUrl: './pop-in.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'app-pop-in',
    },
    imports: [
        CdkPortalOutlet,
    ],
})
export class PopIn extends CdkDialogContainer {
}